import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import initSentry from 'sentry';
import App from 'components/App';

initSentry();

ReactDOM.render(<App />, document.getElementById('root'));
